var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ActivityStatus__c[_vm.value] && _vm.ActivityStatus__c[_vm.value].labelClass)?_c('v-chip',{class:_vm.ActivityStatus__c[_vm.value].labelClass,attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_c('span',[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }